/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject } from "aurelia";
import { bindable } from 'aurelia';
import { ModelTypes } from '@zeus';
import { Calendar } from '@fullcalendar/core';
import { IDialogService } from '@aurelia/dialog';
import dayGridPlugin from '@fullcalendar/daygrid';
import { ICalendarService } from './services/calendar-service';
import { ViewCalendarEventDialog } from './components/view-calendar-event-dialog/view-calendar-event-dialog';

import '@fullcalendar/core/locales/pt-br';

@inject(ICalendarService, IDialogService)
export class CalendarComponentWidget {
  @bindable hideEvents = false;

  calendarHtmlElement
  calendar: Calendar;
  projects: ModelTypes["project"][] = [];

  constructor(
    private service: ICalendarService,
    private dialogService: IDialogService
  ) { }

  attached() {
    this.calendar = new Calendar(this.calendarHtmlElement, {
      plugins: [dayGridPlugin],
      scrollTime: '00:00',
      height: 'auto',
      contentHeight: 'auto',
      themeSystem: 'united',
      locale: 'pt-br',
      moreLinkText: (num) => `+${num} mais`,
      buttonText: {
        today: 'Hoje',
        month: 'Mês',
        week: 'Semana',
        day: 'Dia',
        list: 'Lista'
      },
      initialView: 'dayGridMonth',
      events: this.getEvents.bind(this),
      dayMaxEvents: 4,
      eventContent: (arg) => {
        const { redeSocial, status, calendarDate } = arg.event.extendedProps;

        const socialIcons = {
          instagram: 'camera_alt',
          facebook: 'facebook',
          linkedin: 'work'
        };

        const statusIcons = {
          published: { icon: 'mdi mdi-check-bold', color: 'text-primary-100' },
          draft: { icon: 'mdi mdi-alert-circle-outline', color: 'text-tertiary-300' },
          pendente: { icon: 'mdi mdi-clock-outline', color: 'text-gray-700' }
        };

        const horario = new Date(arg.event.start).toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit'
        });

        const wrapper = document.createElement('div');
        wrapper.classList.add('evento-postagem');
        wrapper.innerHTML =
          `<div class="font-raleway text-caption-base-medium event-content bg-gray-100 dark:bg-gray-600 text-gray-900 dark:text-gray-100">
            <span class="material-icons social-icon mdi mdi-instagram"></span>
            <div>
            <span class="horario">${new Date(calendarDate).toLocaleTimeString('pt-br', {
            hour: '2-digit',
            minute: '2-digit'
          })}</span>
            <span class="material-icons status-icon mdi mdi-clock-outline !text-primary-100">
            </span>
          </div>
          </div>`
          ;

        return { domNodes: [wrapper] };
      },
      eventClick: (async function (event: { event: { extendedProps: any; }; }) {
        const extendedProps = event.event.extendedProps;

        await this.dialogService.open({
          component: () => ViewCalendarEventDialog,
          model: { project: extendedProps },
          lock: false,
          keyboard: ['Escape'],
          startingZIndex: 100,
        });

      }).bind(this)
    });

    this.calendar.render();
  }


  private async getEvents(info, successCallback) {
    const start = info.startStr;
    const end = info.endStr;

    const projects = await this.service.getProjects(start, end);

    const events = projects.map(project => {
      return {
        title: project.alias || '...',
        start: project.calendarDate,
        end: project.calendarDate,
        allDay: true,
        extendedProps: project
      }
    });

    successCallback(events);
  }

}